export default "__VITE_ASSET__DL_BcXo0__"